import React from "react";
import { Link } from "react-router-dom";
import {
    MdLockOutline,
    MdSupportAgent,
    MdLogin,
} from "react-icons/md";

const NoPermission = () => {
    return (
        <div className="min-h-screen bg-white flex items-center justify-center px-4">

            <div className="max-w-md w-full bg-white border border-gray-100 rounded-[32px] shadow-[0_10px_50px_rgba(0,0,0,0.08)] p-8 text-center">

                {/* Animated Lock */}
                <div className="w-24 h-24 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-6 animate-bounce">

                    <MdLockOutline className="w-12 h-12 text-red-500" />

                </div>

                {/* Title */}
                <h1 className="text-3xl font-bold text-gray-800 mb-3 tracking-tight">
                    Access Denied
                </h1>

                {/* Description */}
                <p className="text-sm text-gray-500 leading-relaxed mb-6">
                    You don’t have permission to access this page.
                    Please contact your administrator for access rights.
                </p>

                {/* Support */}
                <div className="bg-gray-50 border border-gray-100 rounded-2xl p-4 flex items-center justify-center gap-2 mb-6">

                    <MdSupportAgent className="w-5 h-5 text-blue-600" />

                    <span className="text-sm font-semibold text-gray-700">
                        Contact Administrator
                    </span>

                </div>

                {/* Login Button */}
                <Link
                    to="/login"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3.5 rounded-2xl flex items-center justify-center gap-2 transition-all duration-300 hover:scale-[1.02] no-underline"
                    style={{ textDecoration: "none" }}
                >

                    <MdLogin className="w-5 h-5" />

                    Back To Login

                </Link>

            </div>

        </div>
    );
};

export default NoPermission;